import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { formatColor, isWithinStartRange } from "@chessalpha/core";
import { Box, Typography } from "@mui/material";
import { green, grey } from "@mui/material/colors";
import { Clock, Color } from "./index.js";
const colors = ["white", "black"];
export const Players = ({ game, node, position, flipped, serverTimestamp, attendances, onOutOfTime, children, }) => (_jsx(_Fragment, { children: colors.map((color) => (_jsxs(Box, { sx: [
            {
                display: "flex",
                alignItems: "center",
                width: "100%",
                lineHeight: "1.6em",
                fontSize: "0.5em",
            },
            +!flipped ^ +(color === "white")
                ? {
                    alignSelf: "flex-start",
                    transform: "translateY(-2em)",
                }
                : {
                    alignSelf: "flex-end",
                    transform: "translateY(2em)",
                },
        ], children: [_jsx(Color, { color: color, badgeColor: attendances
                    ? attendances[game[color].uid]
                        ? green[600]
                        : grey[600]
                    : undefined, sx: { flex: "0 0 auto", marginRight: "2%" } }), _jsx(Typography, { sx: {
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    marginRight: "0.2em",
                    fontSize: "0.8em",
                    lineHeight: "inherit",
                }, children: game[color].name }), node &&
                position &&
                node[`${color}Time`] !== Number.POSITIVE_INFINITY && (_jsx(Clock, { ...game, ...position, ...node, timeLeft: node[`${color}Time`], color: formatColor(color), isWithinStartRange: isWithinStartRange(node), serverTimestamp: serverTimestamp, onOutOfTime: () => onOutOfTime?.(color) })), children?.(color)] }, color))) }));
//# sourceMappingURL=Players.js.map